import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshCw = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 20C5 16.0218 6.58035 12.2064 9.3934 9.3934C12.2064 6.58035 16.0218 5 20 5C24.1934 5.01578 28.2184 6.65204 31.2333 9.56667L35 13.3333M35 13.3333V9M35 13.3333H30.6667M35 20C35 23.9782 33.4196 27.7936 30.6066 30.6066C27.7936 33.4196 23.9782 35 20 35C15.8066 34.9842 11.7816 33.348 8.76667 30.4333L5 26.6667M5 26.6667H9.33333M5 26.6667V31",
		stroke: "#0E3CC0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M19.667 28.3333V20M19.667 20L12.4087 15.8333M19.667 20L26.9253 15.8333M15.917 13.5583L23.417 17.85M18.8337 28.1083C19.087 28.2546 19.3744 28.3316 19.667 28.3316C19.9596 28.3316 20.247 28.2546 20.5003 28.1083L26.3337 24.775C26.5868 24.6289 26.797 24.4187 26.9433 24.1657C27.0895 23.9126 27.1667 23.6256 27.167 23.3333V16.6667C27.1667 16.3744 27.0895 16.0873 26.9433 15.8343C26.797 15.5813 26.5868 15.3711 26.3337 15.225L20.5003 11.8917C20.247 11.7454 19.9596 11.6684 19.667 11.6684C19.3744 11.6684 19.087 11.7454 18.8337 11.8917L13.0003 15.225C12.7472 15.3711 12.537 15.5813 12.3907 15.8343C12.2444 16.0873 12.1673 16.3744 12.167 16.6667V23.3333C12.1673 23.6256 12.2444 23.9126 12.3907 24.1657C12.537 24.4187 12.7472 24.6289 13.0003 24.775L18.8337 28.1083Z",
		stroke: "#0E3CC0",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgRefreshCw;
